import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import ModalConfirmation from "../ModalConfirmation";
import CustomButton from "../CustomButton";

import "./style.scss";

export const BackButton = ({
  onClick,
  onModalConfirm,
  showDataLoseWarning = false,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [confirmModalToggle, setConfirmModalToggle] = useState("");

  const handleClick = () => {
    if (showDataLoseWarning) {
      setConfirmModalToggle("modal-confirm");
    } else {
      if (onClick) {
        onClick();
      } else {
        navigate(-1);
      }
    }
  };

  return (
    <>
      <ModalConfirmation
        modalText={t("createSchedule.go_back_confirm_title")}
        modalSubText={t("createSchedule.go_back_confirm_subtitle")}
        changeModal={setConfirmModalToggle}
        modalValue={confirmModalToggle}
        confirm={onModalConfirm}
      />
      <CustomButton color="primary" onClick={handleClick}>
        {t("go_back")}
      </CustomButton>
    </>
  );
};
